import React, { Component } from 'react';
import CONF from '../../../config/config';
import DocumentSymbol from './../../../assets/img/DocumentSymbol.svg';
import NewDropSelector from './../../../commons/NewDropSelector.js';
import FileUploader from './../../../commons/FileUploader.js';
import PDFViewer from './../../../commons/PDFViewer.js';
import InvoiceControlApiHandler from './../InvoiceControlApiHandler.js'
import ErrorBox from './../../../commons/ErrorBox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tick from './../../../assets/img/tick.png';


var invoiceTypes = ["Tax Invoice", "Bill Of Supply", "Duplicate Invoice", "Credit Bill", "Delivery Slip", "Lorry Receipt", "Extra Copy", "Order Form", "Return Challan", "Others"];

export default class InvoiceControl extends Component {
	constructor(props) {
		super(props);
		this.state = {
			enterDetails : false,
			selectedInvoiceType: null,
			poNumber: undefined,
			addPod: true,
			error: null,
			pods: [],
			invoiceType: null,
			vendorInvoiceNo: undefined,
			invoiceDate: null,
			invoiceAmount: null,
			noOfUniqueItems: null,
			uploadResponse: null,
			loading: false,
			showSuccessScreen: false
		}
		this.proceedForEnterDetails = this.proceedForEnterDetails.bind(this);
		this.poNumberChanged = this.poNumberChanged.bind(this);
		this.closeError = this.closeError.bind(this);
		this.addAnotherPo = this.addAnotherPo.bind(this);
		this.invoiceTypeSelected = this.invoiceTypeSelected.bind(this);
		this.setInvoiceAmount = this.setInvoiceAmount.bind(this);
		this.setInvoiceDate = this.setInvoiceDate.bind(this);
		this.setVendorInvoiceNo = this.setVendorInvoiceNo.bind(this);
		this.setNoOfUniqueItems = this.setNoOfUniqueItems.bind(this);
		this.handleUploadResponse = this.handleUploadResponse.bind(this);
		this.handleInwardingDocCreation = this.handleInwardingDocCreation.bind(this);
		this.buttonClickable = this.buttonClickable.bind(this);
		this.onDeleteClick = this.onDeleteClick.bind(this)
		this.removePOD = this.removePOD.bind(this);
		this.invoiceDateValidation = this.invoiceDateValidation.bind(this);
	}


	//<!------------------------------- Clicked the button to enter PO details -------------------------------!>
	proceedForEnterDetails() {
		this.setState({enterDetails: true});
	}


	//<!------------------------------- Watcher on PO number to get the details from backend -------------------------------!>
	poNumberChanged(e) {
		if(e.target.value && e.target.value.length >= 17) {
			this.getPODDetails(e.target.value);
		}
	}

	//<!------------------------------- If user wants to add another PO -------------------------------!>
	addAnotherPo() {
		this.setState({addPod: true});
	}

	//<!------------------------------- Removing existing PO -------------------------------!>
	removePOD(index) {
		var i = this.state.pods;
		i.splice(index,1);
		if(i.length === 0) {
			this.setState({addPod: true});
		}
		this.setState({pods: i});
	}


	//<!------------------------------- Invoice Type Selected(Which invoice has come with the vehicle) -------------------------------!>
	invoiceTypeSelected(type) {
		this.setState({selectedInvoiceType: type});
	}


	//<!------------------------------- Setting Invoice No -------------------------------!>
	setVendorInvoiceNo(e) {
		this.setState({
			vendorInvoiceNo:e.target.value
		});
	}


	//<!------------------------------- Setting Invoice Date -------------------------------!>
	setInvoiceDate(e) {
		this.setState({
			invoiceDate:e.target.value
		})
	}


	//<!------------------------------- Setting No. of unique items -------------------------------!>
	setNoOfUniqueItems(e) {
		this.setState({
			noOfUniqueItems: e.target.value
		})
	}


	//<!------------------------------- Setting Invoice Amount -------------------------------!>
	setInvoiceAmount(e) {
		this.setState({
			invoiceAmount: e.target.value
		})
	}


	//<!------------------------------- Setting Uploaded Doc (Digital Copy of Invoice) -------------------------------!>
	handleUploadResponse(resp) {
		this.setState({
			uploadResponse : resp
		});
	}


	//<!------------------------------- Removing current doc -------------------------------!>
	onDeleteClick() {
		this.setState({uploadResponse : null});
	}


	//<!------------------------------- Closing Error -------------------------------!>
	closeError() {
		this.setState({
			error: null
		})
	}

	closeSuccessScreen() {
		window.location.reload();
	}

	//<!------------------------------- Validation for Create new invoice -------------------------------!>
	buttonClickable() {
		return (this.state.selectedInvoiceType && this.state.vendorInvoiceNo && this.state.invoiceDate && this.state.invoiceAmount && this.state.noOfUniqueItems && this.state.uploadResponse && this.state.pods.length > 0 && !this.invoiceDateValidation());
	}

	invoiceDateValidation() {
		if(this.state.invoiceDate) {
			var currentDate = new Date();
            var choosedDate = new Date(this.state.invoiceDate);

            var timeDiff = Math.abs(currentDate.getTime() - choosedDate.getTime());
            var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)); 
            if(diffDays > 7) {
                return true;
            }
		}
		return false;
	}


	//<!------------------------------- Getting the POD (Purchase order document) details {Server Call} -------------------------------!>	
	getPODDetails(orderId) {
		InvoiceControlApiHandler.getPODDetails(orderId)
			.then((resp) => {
				this.setState({addPod: false});
				this.setState(prevState => ({
				  pods: [...prevState.pods, resp]
				}))
			}).catch((error) => {
				this.setState({error: error.error.error});
			}).finally(() => {

			})
	}


	//<!------------------------------- Creating New Inwarding Doc -------------------------------!>
	handleInwardingDocCreation(e) {
		var request = {
				invoiceDate: new Date(this.state.invoiceDate).getTime(),
				rpoOrderIds: this.state.pods.map(p => {
					return p.orderId
				}),
				vendorId: this.state.pods.map(p => {
					return p.vendorId
				})[0],
				vendorInvoiceNumber: this.state.vendorInvoiceNo,
				documentId: this.state.uploadResponse,
				numberOfItems: this.state.noOfUniqueItems,
				invoiceAmount: this.state.invoiceAmount,
				invoiceType: this.state.selectedInvoiceType
		};
		this.setState({loading: true})
		InvoiceControlApiHandler.createInwardingDocument(request)
			.then((resp) => {
				this.setState({showSuccessScreen: true})
			}).catch((error) => {
				this.setState({error: error.error.error});
			}).finally(() => {
				this.setState({loading: false})
			})
	}

	
	//<!------------------------------- Showing already scanned PO Details (Render) -------------------------------!>
	showScannedPosRender() {
		var d = this.state.pods.map((p, index) => {
			return (
				<div key={index}>
					<div onClick={() => {this.removePOD(index)}} style={{float:"right", fontSize:"35px"}}><i className="fas fa-times"></i></div>
				<div className="invoice-control-po-number">PO #{index+1}</div>
				<div className="invoice-control-facility-heading">Facility Centre</div>
				<div className="invoice-control-facility-name">{p.facilityName}</div>
				<div className="invoice-control-facility-heading">Vendor Name</div>
				<div className="invoice-control-facility-name">{p.vendorName}</div>
				<div className="invoice-control-facility-heading">Seller Name</div>
				<div className="invoice-control-facility-name" style={{paddingBottom:"40px"}}>{p.sellerName}</div>
				</div>
			);
		})
		return d;
	}


	//<!------------------------------- Showing add new invoice screen (Render) -------------------------------!>
	addNewInvoiceScreenRender() {
		return (
			<div className="white-box" style={{height : 'calc(100vh - 65px)'}}>
				<div className = "add-new-invoice-wrapper">
					<div>
						<img src={DocumentSymbol} alt="docSymbl"/>
					</div>
					<div>
						<button className="btn add-new-invoice-round" onClick={this.proceedForEnterDetails}>+</button>
					</div>
					<div style = {{fontSize:'20px', textAlign: 'center', padding: '20px 20%' }} >
						Click on above button to Create an Inwarding Document
					</div>
				</div>
			</div>
		);
	}

	//<!------------------------------- Landing Screen , asking user to add new invoice (Render) -------------------------------!>
	addPODetailsRender() {
		return(
			<div style={{padding: '20px'}}>
				<div className='white-box'>
					<div style={{'fontSize':'24px'}}>
						Inwarding Document
					</div>
					<hr/>
					<div>
						{this.showScannedPosRender()}
						<div className="row">
							<div className="col-md-4 col-sm-6">
								{(this.state.addPod)?
								<div>
									<div style={{'fontSize':'29px'}}>
										PO #{this.state.pods.length + 1}
									</div>
									<div>
										<input type="text" placeholder="Enter PO number" value={this.state.poNumber} onChange={this.poNumberChanged} className="invoice-text-box"/>
									</div>
								</div>:
								<div style={{textAlign: 'right'}}>
									<button className="blue-big-btn" onClick={this.addAnotherPo}>Add Another POD</button>
								</div>
								}
							</div>
						</div>
					</div>
					<hr/>	
					<div className="row">
						<div className="col-md-4 col-sm-6">
							<div className="invoice-control-header-invoice-details">
								Invoice Details
							</div>
							<div className="top-thirty">
								<div className="item-label">Invoice Type</div>
								<NewDropSelector options={invoiceTypes} selected={this.state.selectedInvoiceType} classes = {{drop: 'invoice-control-drop', option: 'invoice-control-drop-inner'}} selctionChange={this.invoiceTypeSelected} type={'Invoice Type'}/>
							</div>
							<div className="top-twenty">
								<div className="item-label">Vendor Invoice No.</div>
								<input type="text" value={this.state.vendorInvoiceNo} onChange={this.setVendorInvoiceNo} placeholder="Vendor Invoice No." className = "invoice-text-box"/>
							</div>
							<div className="top-twenty">
								<div className="item-label">Invoice Date</div>
								<input type='date' value={this.state.invoiceDate} onChange={this.setInvoiceDate} className="invoice-text-box"
								placeholder='Invoice Date.'/>
								{(this.invoiceDateValidation())?
									<div className="error-text top-ten">Invoice Date can not be more than 7 Days older from today.</div>:null
								}
							</div>
							<div className="top-twenty">
								<div className="item-label">No. Of Unique Items</div>
								<input type="text" value={this.state.noOfUniqueItems} onChange={this.setNoOfUniqueItems} placeholder="No of Unique Items" className = "invoice-text-box"/>
							</div>
							<div className="top-twenty">
								<div style={{"fontSize":"20px"}}>Invoice Amount</div>
								<div className="input-group" style={{"paddingTop" : "10px", width: '100%'}}>
									<span className="input-group-addon" id="basic-addon">
										₹
									</span>
									<input type="number" value={this.state.invoiceAmount} onChange={this.setInvoiceAmount} className="invoice-text-box" placeholder='Invoice Amount' />
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="invoice-control-digital-copy-header top-twenty">
							Digital Copy
								<div className="top-thirty">
								{(this.state.uploadResponse) ? 
									<PDFViewer url={this.state.uploadResponse} onDeleteClick={this.onDeleteClick}/>
									:
									<FileUploader 
										url="inwarding/upload" 
										noMessage="true" 
										handleUploadResponse={this.handleUploadResponse} 
										accept='.pdf'
										fileSizeLimit={CONF.FILE_SIZE_LIMIT_FOR_PDF_IN_BYTES}
									/>
								}
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6" style={{textAlign: 'right'}}>
								{(this.state.loading)?
									<CircularProgress style={{ color:'#000' }} size={40} thickness={3} />:null
								}
								</div>
								<div className="col-sm-6">
									<div style={{textAlign: 'right'}}>
										<button className={"btn choose-button " + ((this.buttonClickable()) ? "btn-jt-green":"btn-default")} style={{fontSize: '20px', lineHeight: '40px'}}  disabled={(this.buttonClickable()) ? false :  true} onClick={this.handleInwardingDocCreation}>Create Invoice Document</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				{(this.state.error)?
		 			<ErrorBox errorText={this.state.error} closeError={this.closeError}/>:null
    			}
			</div>);
	}

	//<!------------------------------- Render Method -------------------------------!>
 	render(){
		return(
			<div>
				{(!this.state.enterDetails) ? 
					<div>
						{this.addNewInvoiceScreenRender()}
					</div>
					:
					<div>
						{this.addPODetailsRender()}
					</div>
				}
				{(this.state.showSuccessScreen)?
			      <div className="randomErrorBox">
			        <div className="errorContianer" style={{width:'300px', textAlign: 'center', color: '#58a159', fontWeight: 'bold'}}>
			          <div><img src={Tick} alt="success-img" style={{width:'65px', height: '65px'}}/></div>
			          <div className="top-twenty">Invoice Created Successfully</div>
			          <div className="top-twenty"><button className="btn btn-jt-green" onClick={this.closeSuccessScreen}>Okay</button></div>
			        </div>
			      </div>:null
			    }
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/screens/InvoiceControl/Components/InvoiceControl.js